import { CdkBrand } from '../app/types/enum';
import { appConfig } from './getAppConfig';
import { getBrand } from '../utils/getBrand';

export const loadAnalyticsLibrary = (): void => {
  const script = document.createElement('script');
  script.setAttribute(
    'src',
    getBrand().cdkBrand == CdkBrand.fido
      ? appConfig.analyticsFidoLibrary
      : appConfig.analyticsRogersLibrary
  );
  script.setAttribute('async', 'true');
  document.head.appendChild(script);
};
